const emptyMetric = '—'

function parseMt(value: string | null | undefined): number | null {
  if (value == null) {
    return null
  }
  const trimmed = value.trim()
  if (!trimmed) {
    return null
  }

  // Support plain values, comma-separated values, and accounting-style negatives.
  const normalized = trimmed.replace(/,/g, '')
  const accountingMatch = normalized.match(/^\((.+)\)$/)
  const numericCandidate = accountingMatch ? `-${accountingMatch[1]}` : normalized
  const parsed = Number(numericCandidate)

  return Number.isFinite(parsed) ? parsed : null
}

function formatAbsToAccounting(value: number): string {
  return `(${Math.abs(value).toFixed(2)})`
}

export function formatMt(value: string | null | undefined): string {
  const parsed = parseMt(value)
  if (parsed == null) {
    return emptyMetric
  }
  if (parsed < 0) {
    return formatAbsToAccounting(parsed)
  }
  return parsed.toFixed(2)
}

export function formatMtAsNegative(value: string | null | undefined): string {
  const parsed = parseMt(value)
  if (parsed == null) {
    return emptyMetric
  }
  return formatAbsToAccounting(parsed)
}
